/* IONZ — presentation layer.
 *
 * Ported from the demo's inline script. The behaviour is unchanged; the wiring is
 * not. Every inline onclick= became a delegated listener, because the theme editor
 * re-renders a section's markup on each edit and inline handlers bound to the old
 * nodes die silently — the section keeps looking right and simply stops responding.
 */
(function () {
  'use strict';

  var STR = (window.IONZ && window.IONZ.strings) || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------ sticky nav */

  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 18); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --------------------------------------------------------- reveal on scroll */

  var revealObserver = null;

  function observeReveals(scope) {
    var els = $$('.reveal:not(.vis)', scope);
    if (!els.length) return;

    /* With reduced motion the animation is the point, so skip straight to the
       resting state rather than leaving content at opacity 0. */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vis'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('vis');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------------------------------------------------------- FAQ accordion */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-faq-toggle]');
    if (!btn) return;

    var qa = btn.parentElement;
    var ans = qa.querySelector('.ans');
    var open = qa.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (ans) ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
  });

  /* An open answer measured in px goes stale when the viewport reflows it. */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $$('.qa.open .ans').forEach(function (ans) { ans.style.maxHeight = ans.scrollHeight + 'px'; });
    }, 150);
  }, { passive: true });

  /* ------------------------------------------------------- background video */

  function initVideo(scope) {
    var v = (scope || document).querySelector('[data-band-video]');
    if (!v) return;

    var btn = document.querySelector('[data-video-toggle]');
    var icon = btn && btn.querySelector('[data-video-icon]');
    var PLAY = '<path d="M8 5l11 7-11 7Z"/>';
    var PAUSE = '<path d="M9 5v14M15 5v14"/>';
    var userPaused = reduceMotion;

    function sync() {
      if (!icon || !btn) return;
      var playing = !v.paused;
      icon.innerHTML = playing ? PAUSE : PLAY;
      btn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; v.play().catch(function () {}); }
        else { userPaused = true; v.pause(); }
        sync();
      });
    }

    if (reduceMotion) { v.pause(); v.removeAttribute('autoplay'); }
    else { v.play().catch(function () {}); }

    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    sync();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { if (!userPaused) v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.15 }).observe(v);
    }
  }

  /* ------------------------------------------------------- newsletter form */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-newsletter]');
    if (!form) return;
    /* Shopify's customer form posts and redirects back with ?customer_posted=true;
       the toast below is only the optimistic acknowledgement. */
    if (window.IONZ && window.IONZ.toast) window.IONZ.toast(STR.newsletter || 'Thanks!');
  });

  if (window.location.search.indexOf('customer_posted=true') > -1) {
    setTimeout(function () {
      if (window.IONZ && window.IONZ.toast) window.IONZ.toast(STR.newsletter || 'Thanks!');
    }, 400);
  }

  /* ------------------------------------------------------------------- boot */

  function boot(scope) {
    observeReveals(scope);
    initVideo(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
